module.exports = __webpack_public_path__ + "img/carousel_3.5656e852.jpg";